import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import './ApoioJuridicoPage.css';

const ApoioJuridicoPage = () => {
  return (
    <>
      <Header />
      
      <div className="apoio-container">
        <div className="apoio-content">
          <div className="apoio-left">
            <div className="apoio-logo">
              <img src="/logo/Logo_Sem_Fundo.png" alt="Veridicus Logo" className="logo-img" />
              <h1 className="overlay-title">APOIO A ESCRITÓRIOS E DEPARTAMENTOS JURÍDICOS</h1>
            </div>
          </div>
          
          <div className="apoio-right">
            
            <div className="apoio-description">
              <p className="apoio-intro">
                Otimize o dia a dia do seu escritório com processos mais claros e organizados.
              </p>
              
              <ul className="apoio-services">
                <li>Protocolo e acompanhamento de processos em Juntas Comerciais</li>
                <li>Diligências em órgãos públicos e cartórios</li>
                <li>Obtenção de certidões e documentos oficiais</li>
                <li>Gestão de prazos e controle de vencimentos</li>
                <li>Organização de documentação societária</li>
                <li>Apoio em rotinas administrativas jurídicas</li>
              </ul>
              
              <p>
                Nossa plataforma centraliza todas as tarefas operacionais, monitorando protocolos, diligências e prazos 
                automaticamente. Documentos oficiais e societários ficam organizados e acessíveis, alertas inteligentes evitam 
                atrasos, e relatórios detalhados garantem controle completo. Dessa forma, sua equipe pode focar em decisões 
                estratégicas enquanto todas as rotinas administrativas acontecem de maneira segura e eficiente.
              </p>
            </div>
            
            <div className="apoio-cta">
              <Link to="/fale-conosco" className="cta-button">
                Entre em contato
              </Link>
            </div>
          </div>
        </div>
        
        <div className="apoio-navigation">
          <Link to="/servicos/terceirizacao" className="nav-prev">
            ← TERCEIRIZAÇÃO DE PROCESSOS
          </Link>
          <Link to="/servicos/consultoria" className="nav-next">
            CONSULTORIA EM REGULARIZAÇÕES E COMPLIANCE →
          </Link>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default ApoioJuridicoPage;